import React, { Fragment } from 'react';
import styled from 'styled-components';

import moment from 'moment-timezone';
import 'moment/locale/es-us';

import Styles from './ShuttleSelectTrip.Styles';
import Text from '../../base/Text';
import ValidateButton from '../TicketsWhite/ValidateButton';
import damaris_logo from '../../../assets/images/damaris_logo.png';
import losLimousines from '../../../assets/images/losLimousines.svg';
import mexicoach_logo from '../../../assets/images/mexicoach_logo.png';

import purple_arrow from "../../../assets/images/purple_arrow.png"
import SelectRadioButton from '../../base/SelectRadioButton/SelectRadioButton';

import CBX_whitleInformation from '../../../assets/images/Shuttle/CBX_whitleInformation.svg';
import CBX_whiteUbication from '../../../assets/images/Shuttle/CBX_whiteUbication.svg';
import CBX_pinkUbication from '../../../assets/images/Shuttle/CBX_pinkUbication.svg';
import CBX_rightArrow from '../../../assets/images/Shuttle/CBX_rightArrow.svg';
import CBX_details from '../../../assets/images/Shuttle/CBX_details.svg';

import gettingData from '../../../assets/images/clock.gif';
import WhiteCalendar from '../../../assets/images/Shuttle/calendar.png';
import cbxCloseIcon from '../../compound/ParkingLot/map/CBX_closeIcon.png';

import { capitalize } from '../../../helpers';
import { getCleanShuttleRoutes } from '../../../helpers/CartManager';
import processing from '../../../assets/images/clock.gif';

const providers_logos = {
  "abc": losLimousines,
  "mexicoach": mexicoach_logo,
  "damaris": damaris_logo
}

const Container = styled.div`${Styles.container}`;
const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const ButtonContainer = styled.div`${Styles.buttonContainer}`;
const StartPointElement = styled.div`${Styles.startPointElement}`;
const NotInclude = styled.div`${Styles.notInclude}`;
const PinkText = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.pinkText}`; // prettier-ignore
const LabelPage = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.labelPage}`; // prettier-ignore
const PurpleUsd = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.purpleUsd}`; // prettier-ignore

const Contain = styled.div`${Styles.contain}`;
const Circle = styled.div`${Styles.circle}`;
const Line = styled.div`${Styles.line}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const ModalWrapper = styled.div`${Styles.modalWrapper}`; // prettier-ignore
const Dialog = styled.div`${Styles.dialog}`; // prettier-ignore
const Header = styled.div`${Styles.header}`; // prettier-ignore
const Title = styled.h3`${Styles.title}`; // prettier-ignore
const Footer = styled.div`${Styles.footer}`; // prettier-ignore
const RouteContainer = styled.div`${Styles.routeContainer}`; // prettier-ignore
const Input = styled.input`${Styles.input}`;
const GrayContainer = styled.div`${Styles.grayContainer}`; // prettier-ignore
const Label = styled(Text).attrs({ bold: true })`${Styles.labelInput}`; // prettier-ignore
const CartSection = styled.div`${Styles.cartSection}`;


const Item = ({
  isSelectedTrip,
  changeTripSelect,
  translations,
  id,
  data,
  i,
  saveShuttleTripData,
  showModalScales,
  showScales,
  handleDetailSelected,
  detailSelected

}) => {

  const select = (id, data) => {
    changeTripSelect(id)
    saveShuttleTripData(data, id)
  };


  const showScaleModal = (id, event) => {
    showModalScales(event);
    handleDetailSelected(id)

  };

  return (
    <Container>
      <Row>
        <Column style={{ display: "inline-flex", alignItems: "center" }}>
          <Text style={{ color: "#726C79", fontSize: "16px" }}>{translations.depart}</Text>
          <Text style={{ color: "#3F2A55", fontWeight: "bolder", fontSize: "20px" }}>{moment(data[i].departureDateTime).format('HH:mm A')}</Text>
          <Text style={{ color: "#3F2A55", fontWeight: "bolder", fontSize: "12px" }}>{moment(data[i].departureDateTime).format('YYYY-MM-DD')}</Text>
        </Column>
        <Column style={{ alignItems: "center", justifyContent: "center" }}>
          <Text style={{ color: "#3F2A55", fontWeight: "bolder", fontSize: "12px", textAlign: "center", marginBottom: 0 }}>{data[i].travelTime.replace(':', ' h ')} min </Text>
          <Stepper />
          <Text style={{ color: "#FF3094", textAlign: "center" }}>{data[i].scales.length > 1 ? (data[i].scales.length > 2 ? data[i].scales.length - 1 + translations.transfers + "S" : data[i].scales.length - 1 + translations.transfers) : translations.noTransfers}</Text>
        </Column>
        <Column style={{ display: "inline-flex", alignItems: "center" }}>
          <Text style={{ color: "#726C79", fontSize: "16px" }}>{translations.arrival}</Text>
          <Text style={{ color: "#3F2A55", fontWeight: "bolder", fontSize: "20px" }}>{moment(data[i].arrivalDateTime).format('HH:mm A')}</Text>
          <Text style={{ color: "#3F2A55", fontWeight: "bolder", fontSize: "12px" }}>{moment(data[i].arrivalDateTime).format('YYYY-MM-DD')}</Text>
        </Column>
        <Column></Column>
        <Column style={{ alignItems: "center", }}>
          <Text style={{ color: "#726C79", fontSize: "10px" }}>{translations.serviceProvider}</Text>
          <img
            alt=""
            height="50px"
            style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px', display: "block" }}
            src={providers_logos[data[i].provider]}
          />
        </Column>
        <div style={{ height: "auto", backgroundColor: "#D8D8D8", width: "1px" }}></div>
        <Column style={{display:"flex"}}>
          <Text style={{ color: "#726C79" }}>{translations.details}</Text>
          <img
            alt=""
            width={"40px"}
            height="50px"
            style={{ marginInline: 'auto', cursor: 'pointer' }}
            src={CBX_details}
            onClick={(event) => showScaleModal(id, event)}
          />
        </Column>
        <div style={{ height: "auto", backgroundColor: "#D8D8D8", width: "1px" }}></div>
        <Column>
          <Text style={{ color: "#726C79" }}>{translations.standarFare}</Text>
          <PinkText>${(parseInt(data[i].passengersQ) * data[i].price).toFixed(2)}</PinkText>
          <Text style={{ color: "gray" }}>{translations.person}
            <PinkText style={{ fontSize: "12px" }}> $ {parseFloat(data[i].price).toFixed(2)}</PinkText></Text>
        </Column>

        <div style={{ height: "auto", backgroundColor: "#D8D8D8", width: "1px" }}></div>
        <Column onClick={() => select(id, data[i])}>
          <Text style={{ color: "#726C79" }}>{translations.select}</Text>
          <SelectRadioButton id={id} isSelected={isSelectedTrip} style={{ margin: "auto" }} />
        </Column>
      </Row>
    </Container>);
};

const Stepper = () => {
  return (
    <Contain>
      <Circle />
      <Line />
      <Circle />
    </Contain>)
}

/**
* TicketInfo component
* @returns {JSX.Element}
*/
const ShuttleSelectTrip = ({
  isSelectedTrip,
  changeTripSelect,
  translations,
  quantityPersons,
  nontIncludeShow,
  showModalFeet,
  shuttlePassengers,
  shuttleOrigin,
  shuttleDestination,
  shuttlePassengersHandler,
  shuttleOrigins,
  shuttleDestinations,
  shuttleDestinationHandler,
  shuttleOriginHandler,
  saveShuttleTripData,
  shuttlStartDateHandler,
  shuttleStartDate,
  shuttleTravelType,
  shuttleTravelTypeHandler,
  openShuttleForm,
  locale,
  getShuttleRoutes,
  showScales,
  showModalScales,
  handleDetailSelected,
  detailSelected,
  openHome,
  getSeats,
  cart,
  selectRoundTrip,
  page,
  ticketType,
  shuttleEndDateHandler,
  shuttleEndDate,
  isCallingShuttleApi
}) => {

  let requestType = page === "shuttleSelectRoundTrip" ? "round" : "oneway";

  if (locale === 'es') {
    moment.locale('es-us');
  } else {
    moment.locale('en');
  }
  moment.locale(locale);

  let routesData = { data: [] };
  let quickData = {};

  if (typeof window !== 'undefined') {
    routesData = JSON.parse(window.localStorage.getItem(requestType === "round"
      ? 'CBX_Shuttle_Return_Routes'
      : 'CBX_Shuttle_Routes'));

    if (!routesData) {
      routesData = { data: [] };
    }
    quickData = JSON.parse(window.localStorage.getItem('CBX_Quick_Data'));
    if (!quickData) {
      quickData = {
        shuttleOrigin,
        shuttleDestination,
        shuttleStartDate,
        shuttlePassengers
      };
    }
  }

  const items = [];

  if (getCleanShuttleRoutes() === 0) {
    for (let i = 0; i < routesData.data.length; i++) {
      items.push(<Item
        damaris={true}
        changeTripSelect={changeTripSelect}
        isSelectedTrip={isSelectedTrip}
        translations={translations}
        id={i}
        data={routesData.data}
        i={i}
        saveShuttleTripData={saveShuttleTripData}
        rideId={routesData.data.rideId}
        showScales={showScales}
        showModalScales={showModalScales}
        detailSelected={detailSelected}
        handleDetailSelected={handleDetailSelected}
      />)
    }
  }

  const selectedRoute = routesData && routesData.data[isSelectedTrip];
  let totalAmount = null;
  if (selectedRoute) {
    totalAmount = parseInt(selectedRoute.passengersQ, 10) * selectedRoute.price;
  }

  const Origin = () => {
    return (
      <StartPointElement style={{
        display: "flex"
      }}>
        <img
          alt=""
          width="30px"
          height="20px"
          style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px', marginBottom: "2px" }}
          src={CBX_whiteUbication}
        />
        <Select
          onChange={shuttleOriginHandler}
          value={shuttleOrigin}
          defaultValue={quickData.shuttleOrigin}
        >
          <option value="" disabled>{locale === 'es' ? "Seleccionar" : "Select"}</option>
          {shuttleOrigins && Object.keys(shuttleOrigins.data).filter((origin) => (!isBundle || [
            "ANAHEIM(1440 S Anaheim Blvd)",
            "El Monte (11850 Valley Blvd #306)",
            "Huntington Park (2470 E Florence Ave)",
            "Las Vegas (1100 S Main St)",
            "Los Angeles (260 E 6th St)",
            "San Bernardino (620 W Mill St Suite A)",
          ].includes(origin))).map((option, i) => (
            <option selected={option === shuttleOrigin} value={option} key={`inputValue${i + 1}`}>
              {capitalize(option)}
            </option>
          ))}
        </Select>
      </StartPointElement>
    )
  };

  const Destination = () => {
    return (
      <StartPointElement >
        <img
          alt=""
          width="30px"
          height="20px"
          style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px', marginBottom: "2px" }}
          src={CBX_whiteUbication}
        />

        <Select
          onChange={shuttleDestinationHandler}
          value={shuttleDestination}
          defaultValue={quickData.shuttleDestination}
        >
          <option value="" disabled>{locale === 'es' ? "Seleccionar" : "Select"}</option>
          {shuttleDestinations && Object.keys(shuttleOrigins.data).filter((destination)=>(!isBundle || ["CROSS BORDER XPRESS"].includes(destination))).map((option, i) => (
            <option selected={option === shuttleDestination} value={option} key={`inputValue${i + 1}`}>
              {capitalize(option)}
            </option>
          ))}
        </Select>
      </StartPointElement>

    )
  }

  const sendInfo = (page) => {
    getSeats(selectedRoute.rideId, page);
  }

  const currentFlow = typeof window !== 'undefined' ? window.localStorage.getItem('currentFlow') : null;
  const isBundle = currentFlow === 'Bundles' && page === 'shuttleSelectTrip';

  return (
    <>
      <Fragment style={{ flex: 1 }}>
        <LabelPage
        >
          <img
            alt=""
            width="30px"
            height="20px"
            style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px' }}
            src={purple_arrow}
            onClick={openHome}
          />
          {requestType === "round" ? translations.selectTripBack : translations.selectTrip}
        </LabelPage>
        {requestType === "round" &&
          (<CartSection>
            <GrayContainer>
              <Label color="#726C79">{shuttlePassengers} x {translations.shuttle} - {shuttleOrigin} {translations.destinationLabel.toLowerCase()} {shuttleDestination}</Label>
            </GrayContainer>
          </CartSection>
          )}
        <Row style={{ display: "flex", justifyContent: "start", marginBottom: "30px" }}>
          <StartPointElement style={{
            display: "flex", alignItems: "center", justifyContent: "center"
          }} >
            <Input type="date"
              value={requestType === "round" ? shuttleEndDate : shuttleStartDate}
              onChange={requestType === "round" ? shuttleEndDateHandler : shuttlStartDateHandler}
              icon={WhiteCalendar}
              style={{ width: "25px", height: "21px", color: "#3F2A55", marginRight: "15px" }}
              min={isBundle ? '2023-11-29' : null}
              max={isBundle ? '2023-12-12' : null}
            />
            <div style={{ margin: '0px', width: "90px" }}>{ requestType === "round" ? ( shuttleEndDate  || "dd/mm/aaaa" ) : ( shuttleStartDate || "dd/mm/aaaa")}</div>
          </StartPointElement>
          <StartPointElement
          >
            {translations.shoppingLabels.passengers}{"     "}
            <Select
              onChange={shuttlePassengersHandler}
              value={shuttlePassengers}
            >
              {quantityPersons && quantityPersons.filter(option => (!isBundle || option.value === 1)).map((option, idx) => (
                <option value={option.value} key={`inputValue${idx}${option.value}`}>
                  {option.name}
                </option>
              ))}
            </Select>
          </StartPointElement>
          <StartPointElement >
            {translations.shoppingLabels.type}
            <Select
              onChange={shuttleTravelTypeHandler}
              value={shuttleTravelType}
            >
              <option selected={shuttleTravelType === 'oneway'} value="oneway">{translations.shoppingLabels.oneway}</option>
              {!isBundle && <option selected={shuttleTravelType === 'round'} value="round">{translations.shoppingLabels.roundtrip}</option>}
            </Select>
          </StartPointElement>
          <RouteContainer>
            {requestType === "round" ? <Destination /> : <Origin />}
            <img
              alt=""
              width="30px"
              height="30px"
              style={{
                marginInline: '10px',
                cursor: 'pointer',
                backgroundColor: "#D8D8D8",
                padding: "5px 3px",
                marginTop: "5px",
                borderRadius: "32px", marginBottom: "2px"
              }}
              src={CBX_rightArrow}
            />
            {requestType === "round" ? <Origin /> : <Destination />}
            <ButtonContainer style={{ flex: 0.5, marginTop: "5px", marginLeft: "10px" }}>
              <ValidateButton
                disabled={!shuttleOrigin || !shuttleDestination || !shuttlePassengers || !shuttleStartDate || !shuttleTravelType}
                message={locale === "es" ? "Buscar" : "Search"}
                action={() => getShuttleRoutes(requestType)}
                textColor="white"
                style={{ padding: "5px 25px !important" }}
              />
            </ButtonContainer>
          </RouteContainer>
        </Row>
        {items.length > 0 && <NotInclude style={{ marginBottom: "20px" }} >
          <img
            height="20px"
            style={{ marginInline: 'auto', cursor: 'pointer', paddingRight: '10px', marginLeft: "40px", marginBottom: "2px" }}
            src={CBX_whitleInformation}
            onClick={showModalFeet}
          />
          {translations.notInclude}</NotInclude>}
        {isCallingShuttleApi && (
          <div
            style={{
              padding: '5%',
              width: '100%',
              margin: 'auto',
              justifyContent: 'center'
            }}
          >
            <img
              alt=""
              style={{ margin: 'auto', display: 'block ' }}
              width="150px"
              height="auto"
              src={gettingData}
            />
          </div>
        )}
        {nontIncludeShow && (
          <ModalWrapper>
            <Dialog>
              <div style={{
                display: 'flex', justifyContent: 'flex end', marginRight: 15,
                marginTop: "10px", cursor: 'pointer'
              }} onClick={showModalFeet} >
                <img alt="Close" src={cbxCloseIcon} />
              </div>
              <Header border style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Title className="cbx-bold" style={{ textAlign: 'right', cursor: 'pointer' }}
                >{translations.attention}</Title>
                <Text style={{ marginTop: "25px" }}>{translations.warnText}</Text>
              </Header>
              <Footer className="modal-footer">
              </Footer>
            </Dialog>
          </ModalWrapper>
        )}
        {!isCallingShuttleApi && items}
        {totalAmount > 0 && !isCallingShuttleApi &&
          <>
            <PurpleUsd>Total: ${totalAmount.toFixed(2)} USD</PurpleUsd>
            <ButtonContainer style={{ flex: 0.5 }}>
              <ValidateButton
                disabled={!totalAmount}
                message={translations.continueLabel}
                action={() => shuttleTravelType === 'round' && page !== "shuttleSelectRoundTrip" ? sendInfo(page) : sendInfo(page)}
                textColor="white"
                style={{ padding: "5px 25px !important" }}

              />
            </ButtonContainer>
          </>}
      </Fragment>
    </>
  )
};


export default ShuttleSelectTrip;
